import {
  BridgeType,
  callGrowthMSIBridge,
  callKNBBridge,
  callMSIBridge,
  getBridgeType,
} from "./base";
import type { LoginOptions } from "../../types/api.d";
import { reportCustomMetric } from "../owl";

type LoginErrMsg =
  | "success"
  | "KNBBridgeFail"
  | "MSIBridgeFail"
  | "KNBLogoutFail"
  | "MSILogoutFail"
  | "GrowthMSIBridgeFail"
  | "GrowthMSILogoutFail";
// 上报 login 成功率
function reportLoginSuccessRate(
  isSuccess: boolean,
  isLoginExpired: boolean,
  errMsg: LoginErrMsg = "success",
) {
  const bridgeType = getBridgeType();
  reportCustomMetric({
    key: "login",
    value: isSuccess ? 1 : 0,
    tags: {
      errMsg,
      bridgeType,
      isLoginExpired: isLoginExpired ? "loginExpired" : "notLoginExpired",
    },
  });
}

export function loginInMtApp(options: LoginOptions): void {

  const handleLoginFail = (err: any, isLoginExpired: boolean, reportErrMsg: LoginErrMsg) => {
    reportLoginSuccessRate(false, isLoginExpired, reportErrMsg);
    if (typeof options?.onLoginFail === "function") {
      options.onLoginFail(err);
    }
  };

  const bridgeType = getBridgeType();
  switch (bridgeType) {
    case BridgeType.KNB:
      if (options.isLoginExpired) {
        callKNBBridge("logout", {
          success: () => {
            callKNBBridge("login", {
              success: (user: any) => {
                reportLoginSuccessRate(true, true, "success");
                // 登录成功，缓存用户信息
                if (user?.userId && options?.onLoginSuccess) {
                  options?.onLoginSuccess({
                    userId: user.userId,
                    token: user.token || "",
                  });
                }
              },
              fail: (err: any) => handleLoginFail(err, true, "KNBBridgeFail"),
            });
          },
          fail: (err: any) => handleLoginFail(err, true, "KNBLogoutFail"),
        });
      } else {
        callKNBBridge("login", {
          success: (user: any) => {
            // 登录成功，缓存用户信息
            reportLoginSuccessRate(true, false, "success");
            if (user?.userId && options?.onLoginSuccess) {
              options?.onLoginSuccess({
                userId: user.userId,
                token: user.token || "",
              });
            }
          },
          fail: (err: any) => handleLoginFail(err, false, "KNBBridgeFail"),
        });
      }

      break;
    case BridgeType.MSI:
      if (options.isLoginExpired) {
        callMSIBridge("mtLogout", {
          success: () => {
            callMSIBridge("mtLogin", {
              success: (user: any) => {
                reportLoginSuccessRate(true, true, "success");
                if (options?.onLoginSuccess) {
                  options?.onLoginSuccess(user);
                }
              },
              fail: (err: any) => handleLoginFail(err, true, "MSIBridgeFail"),
            });
          },
          fail: (err: any) => handleLoginFail(err, true, "MSILogoutFail"),
        });
      } else {
        callMSIBridge("mtLogin", {
          success: (user: any) => {
            // 登录成功，缓存用户信息
            reportLoginSuccessRate(true, false, "success");
            if (options?.onLoginSuccess) {
              console.log("mtlogin success callback", user, JSON.stringify(user));
              options?.onLoginSuccess(user);
            }
          },
          fail: (err: any) => handleLoginFail(err, false, "MSIBridgeFail"),
        });
      }
      break;
    case BridgeType.GROWTH_MSI:
      if (options.isLoginExpired) {
        callGrowthMSIBridge("mtLogout", {
          success: () => {
            callGrowthMSIBridge("mtLogin", {
              success: (user: any) => {
                reportLoginSuccessRate(true, true, "success");
                if (typeof options?.onLoginSuccess === "function") {
                  options?.onLoginSuccess(user);
                }
              },
              fail: (err: any) => handleLoginFail(err, true, "GrowthMSIBridgeFail"),
            });
          },
          fail: (err: any) => handleLoginFail(err, true, "GrowthMSILogoutFail"),
        });
      } else {
        callGrowthMSIBridge("mtLogin", {
          success: (user: any) => {
            // 登录成功，缓存用户信息
            reportLoginSuccessRate(true, false, "success");
            if (typeof options?.onLoginSuccess === "function") {
              options?.onLoginSuccess(user);
            }
          },
          fail: (err: any) => handleLoginFail(err, false, "GrowthMSIBridgeFail"),
        });
      }
      break;
    default:
      break;
  }
}

// https://msi-extend.sankuai.com/api?id=1298&tab=C
